
















import { Component, Vue, Mixins } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import ScholarshipSetting from "./ScholarshipSetting.vue";
import DrawsSetting from "./DrawsSettings.vue";
import PotentialSwitch from "@/components/common/edit/PotentialSwitch.vue";
import DashLine from "@/components/common/edit/DashLine.vue";
import { majorNoticeText } from "@/common/constants/index";
import getUrlParam from "@/common/utils/getUrlParam";
import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";

@Component({
  components: {
    "potential-switch": PotentialSwitch,
    "draws-setting": DrawsSetting,
    "scholarship-setting": ScholarshipSetting,
    "dash-line": DashLine,
    "activity-switch": ActivitySwitch,
  },
})
export default class ScholarshipProgram extends Vue {
  @Getter("section") section!: any;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("groupSwitch") groupSwitch!: boolean;
  @Getter("xcxType") xcxType!: string;

  @Action("switchPotentialJoin") switchPotentialJoin!: Function;

  type: string = getUrlParam("type") as string;

  handleGroupSwitch(status: boolean): void {
    const origin = getUrlParam("origin");
    if (this.xcxType === "mkb") {
      return;
    }
    if (origin == "ordinary") {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定",
      });
      return;
    }
    if (this.type !== "reEdit") {
      this.switchPotentialJoin(status);
    } else {
      Vue.$toast.error("发布活动后不可修改开启限制");
    }
  }
}
